import './cartItems.css';
import { Link } from 'react-router-dom';
import React, { useContext } from 'react';
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/cart_cross_icon.png';

const CartItems = () => {
  const { getTotalCartAmount, all_product, cartItems, removeFromCart, selectedSizes } = useContext(ShopContext);
  const shippingCharges = 200;

  const createOrderMessage = () => {
    let message = "Hello, I would like to place an order with the following items:\n\n";

    all_product.forEach((e) => {
      const quantity = cartItems[e.id];
      if (quantity > 0) {
        const size = selectedSizes?.[e.id] || 'NA';
        let adjustedPrice = e.new_price;

        // Adjust price if the size is "Unstitched"
        if (size === "Unstitched") {
          adjustedPrice = e.new_price - 1000;
        }

        message += `Title: ${e.name}\nPrice: PKR ${adjustedPrice}\n\nSize: ${size}\nQuantity: ${quantity}\nTotal: PKR ${adjustedPrice * quantity}\n\n`;
      }
    });

    message += `Subtotal: PKR ${getTotalCartAmount()}\nShipping: PKR ${shippingCharges}\nTotal: PKR ${getTotalCartAmount() + shippingCharges}\n\nPlease confirm the order.`;
    return message;
  };

  const hasItemsInCart = Object.values(cartItems).some((quantity) => quantity > 0); // Added check for empty cart

  if (!hasItemsInCart) {
    return (
      <div className='emptycart'>
        <p>No items are added in the cart &nbsp; <Link to="/">Shop Now</Link> </p>
      </div>
    );
  }

  // Prepare simple data to pass through state
  const productsInCart = all_product.filter(e => cartItems[e.id] > 0).map(e => ({
    id: e.id,
    image: e.image, // ✅ ADD THIS LINE
    name: e.name,
    quantity: cartItems[e.id],
    size: selectedSizes?.[e.id] || 'NA',
    price: e.new_price
  }));

  return (
    <div className='cartitems'>
      <h1 className='order-summary'>Order Summary</h1>
      <div className="cartitems-format-main">
        <p>Product</p>
        <p>Title</p>
        <p>Total</p>
        <p>Size</p>
        <p>Qty</p>
        <p>Remove</p>
      </div>
      <hr />
      {all_product.map((e) => {
        const quantity = cartItems[e.id];
        const size = selectedSizes?.[e.id] || 'NA';
        if (quantity > 0) {
          let adjustedPrice = e.new_price;
          
          // Adjust the price if the selected size is "Unstitched"
          if (size === "Unstitched") {
            adjustedPrice = e.new_price - 1000;
          }

          return (
            <div key={e.id}>
              <div className="cartitems-format cartitems-format-main">
                <img src={e.image} alt="" className='carticon-product-icon' />
                <p>{e.name}</p>
                <p>PKR {adjustedPrice}</p>
                <p>{size}</p>
                <button className='cartitem-quantity'>{quantity}</button>
                <img 
                  src={remove_icon} 
                  onClick={() => removeFromCart(e.id)} 
                  alt="remove icon" 
                />
              </div>
              <hr />
            </div>
          );
        }
        return null;
      })}
      <div className="cartitems-down">
        <div className="cartitems-total">
          <h1>Cart Total</h1>
          <div>
            <div className="cartitems-total-item">
              <p>Subtotal</p>
              <p>PKR {getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <p>Shipping Charges</p>
              <p>{shippingCharges}</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <h3>Total</h3>
              <h3>PKR {getTotalCartAmount() + shippingCharges}</h3>
            </div>
          </div>
          <Link to="/order" state={{ productsInCart, totalAmount: getTotalCartAmount()  }}>
            <button>
              <h3>Order Now</h3>
            </button>
          </Link>
        </div>
        <div className="cartitems-promocode">
          <p>If you've a promo code, enter it here</p>
          <div className="cartitems-promobox">
            <input type="text" placeholder='Promo Code' />
            <button>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItems;
